import config from "../../src/common/default_config";

export default class options extends config {
  // Kiosk settings

  // pdf options
  static page_ratio = 1.4745;
  static page_width_reference = 100000;
  static page_height_reference = 100000;

  static page_ratio = 1.4745;
  static page_width_reference = 100000;
  static page_height_reference = 100000;
  static usePdfDesktop = true;
  static usePdfPhoneNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfPhone = true;
  static usePdfTabletNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfTablet = true;

  static replicaReadingModeToggle = {
    phone: false,
    tablet: true,
    desktop: true,
  };
  static replicaReadingModeDefault = {
    phone: false,
    tablet: false,
    desktop: true,
  };

  // social sharing
  static sharingOptions = {
    Facebook: true,
    WhatsApp: true,
    TwitterX: true,
    Mail: true,
    MailSubject: null,
    MailSubjectIntro: "",
  };
  static dateFormat = "Do MMMM YYYY";

  static socialSharingHash = "social";
  static shareFromReader = true;
  static topNavButtonLabel = "Suche";
  static useSliderForPromospot = true;
  static useSliderForHorsSeries = true;
  static useSliderForArchive = true;
  static extraLinkDirectAccess = true;
  static editor = "KREISZEITUNG Böblinger Bote Wilhelm Schlecht GmbH & Co. KG";
  static printCroppedPdf = true;
  static singlePageView = true;
  static usePdfTablet = true;

  static pdfDownloadButtonsConfig = {
    ...config.pdfDownloadButtonsConfig,
    touchDownloadPdf: true,
  };

  static printArticle = true;
  static enrichment_placement_vertical = "bottom"; // [top || bottom || center];
  static enrichment_placement_horizontal = "right"; // [left || right || center];
  static showPrivacyPolicy = true;
  static maxfontSize = 24;

  static voucher = {
    ...config.voucher,
    isEnabled: true,
    dateFormat: "DD/MM/YYYY",
  };
}



// WEBPACK FOOTER //
// ./clients/swmh-kbb/config.js